import React from "react";
import { Shield, ArrowRight } from "lucide-react";
import WaveDivider from "./WaveDivider";
import { useLanguage } from "../contexts/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();

  // Dynamic scroll: measures the real sticky header height at click time
  // (accounting for iOS safe-area, mobile viewport, header padding changes),
  // so target lands right under the header instead of behind it.
  const scrollToEl = (selector) => {
    const el = document.querySelector(selector);
    if (!el) return;
    const header = document.querySelector(".mag-header");
    const headerH = header ? header.getBoundingClientRect().height : 0;
    const top = el.getBoundingClientRect().top + window.scrollY - headerH - 8;
    window.scrollTo({ top, behavior: "smooth" });
  };

  return (
    <section className="mag-hero" id="home">
      <div className="mag-hero-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/hero-image.jpg)` }} />
      <div className="mag-hero-overlay" />
      <div className="mag-hero-content">
        <h1>{t.hero.title}</h1>
        <p className="mag-hero-sub">{t.hero.subtitle}</p>
        <div className="mag-hero-ctas">
          <button className="btn btn-primary" onClick={() => scrollToEl("#contact-cards")}>
            <Shield size={18} />
            {t.hero.ctaContact}
          </button>
          <button className="btn btn-outline" onClick={() => scrollToEl("#services")}>
            {t.hero.ctaServices}
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
      <WaveDivider position="bottom" color="#ffffff" />
    </section>
  );
};

export default Hero;
